export default __webpack_public_path__ + "static/media/kp.38ef4888.svg";